export default __webpack_public_path__ + "static/media/IQVIA_Logo.31e40c55.png";